// @flow

import type { TaskInstance, TaskInstanceStatus } from '../../common/typings';

export default function updateSubtaskStatus(
  taskInstance: TaskInstance,
  subtaskId: number,
  subtaskStatus: TaskInstanceStatus
): TaskInstance {
  return {
    ...taskInstance,
    // $FlowFixMe
    subtasks: taskInstance.subtasks?.map(subtask => ({
      ...subtask,
      status: subtask.id === subtaskId ? subtaskStatus : subtask.status
    }))
  };
}
